import { _notNil } from '@/littledash';
import type { AgentSessionV1, SendBundleValidationResult } from '@/model/Agent.model';

/**
 * Narrow an execution result to a {@link SendBundleValidationResult} by shape: the validation result
 * is the one carrying both `per_domain` and `cross_domain`. Returns null for any other shape.
 */
export const asBundleValidationResult = (value: unknown): SendBundleValidationResult | null => {
  if (typeof value === 'object' && value !== null && 'per_domain' in value && 'cross_domain' in value) {
    return value as SendBundleValidationResult;
  }
  return null;
};

/**
 * Find the validation result by SHAPE across all executions on the session, rather than by array
 * position. A SEND session carries two executions on one thread (detection then validation) and the
 * API returns them newest-first, so a position-based lookup would read the wrong one. The bundle
 * validation result is keyed on `per_domain`/`cross_domain`.
 */
export const findBundleValidationResult = (session: AgentSessionV1 | null): SendBundleValidationResult | null => {
  for (const execution of session?.executions ?? []) {
    const validation = asBundleValidationResult(execution?.result);
    if (_notNil(validation)) {
      return validation;
    }
  }
  return null;
};
